export default () => ({
  country: "bih",
  intl: {
    fallbackLng: "bs",
    locales: [
      {
        locale: "bs",
        label: "Bosnia"
      }
    ],
    defaultLocales: [
      {
        locale: "bs",
        label: "Bosnia"
      }
    ]
  },
  api: {
    user: {
      workZipCode: "BIH"
    }
  },

  serverTimeZone: 2,

  footer: {
    copyright: "© Cineplexx BH d.o.o.",
    apps: {
      android: "https://play.google.com/store/apps/details?id=ba.cineplexx.app",
      ios: "https://itunes.apple.com/ba/app/cineplexx-bih/id1503245948"
    }
  },

  supportInfo: {
    contactUs: {
      email: "kino@cineplexx.ba"
    }
  },

  form: {
    validation: {
      zip: 5
    }
  },

  wizard: {
    stepTickets: {
      warnings: {
        en: [
          {
            title:
              '<strong>Cineplexx Titan || <span class="_accent">Attention!</span></strong> The 1 + 1 offer is only available at <strong>Cineplexx Titan (Bucharest)</strong> for tickets purchased at the desk, not online!',
            description:
              "Pay at the cinema to receive a bonus ticket for every cinema ticket purchased"
          }
        ],
        bs: [
          {
            title:
              '<strong>Cineplexx Titan || <span class="_accent">Atenție!</span></strong> Oferta 1 + 1 este disponibilă doar la <strong>Cineplexx Titan (București)</strong> pentru biletele achiziționate la casele de bilete, nu și online!',
            description:
              "Pentru a beneficia de un bilet bonus pentru fiecare bilet de film cumpărat, plătește la cinema."
          }
        ]
      }
    },
    stepCheckout: {
      messages: {
        en: [
          "Tickets purchased online cannot be changed or canceled and their value will not be refunded.",
          "3D glasses are not included in the ticket price for 3D films and can only be purchased at the cinema box office."
        ],
        bs: [
          "Ulaznice kupljene online ne mogu biti promijenjene, otkazane ili refundirane.",
          "3D naočale nisu uključene u cijenu ulaznica za 3D filmove, a mogu se kupiti isključivo na blagajni kina."
        ]
      }
    }
  },
  showingOptions: {
    member: true,
    giftcards: false,
    streaming: false,
    whatchList: true,
    cinemaRent: true,
    advertising: true,
    newsletter: false,
    newsletterfooter: false,
    newsletterpopup: false,
    information: true,
    followUs: true,
    wishToReceiveSMS: false,
    contactByThirdParty: false,
    myBonusCard: false,
    myGiftCard: false,
    displayTechnologies: true,
    privacyPolicy: true,
    b2bAdvertising: true,
    weeklynewsletter: false,
    familynewsletter: false,
    operanewsletter: false,
    ageratingvisible: false,
    schoolcinema: true,
    childtickets: true,
    company: {
      press: false,
      portrait: false,
      jobs: false
    },
    refundTickets: false,
    club: {
      bonusCard: false,
      familyFilmclub: false,
      competitions: false
    },
    giftCards: {
      giftcardShop: false,
      giftcardInfo: false
    }
  }
});
